import React from 'react';
import classNames from 'classnames';

import BaseProps from "../../types/BaseProps";

import './Wizard.scss';

export interface WizardStepProps {
  prev: () => void,
  next: (progress: any) => void,
  skip: () => void,
}

export type WizardStep = {
  name: string;
  component: any;
  descr: string;
}

type WizardState = {
  currentStep: number;
  skippedSteps: Array<number>
}

type WizardProps = {
  steps: Array<WizardStep>;
}

export class Wizard extends React.Component<WizardProps & BaseProps, WizardState> {

  constructor(props: any) {
    super(props);
    this.state = {
      currentStep: 0,
      skippedSteps: []
    };
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.skip = this.skip.bind(this);
  }

  private setCurrentStep(id: number) {
    this.setState({
      currentStep: id
    });
  }

  private nextStep() {
    const id = this.state.currentStep < this.props.steps.length ? this.state.currentStep + 1 : this.state.currentStep;
    this.setCurrentStep(id)
  }

  next(progress: Promise<boolean> | boolean) {
    if (progress instanceof Promise) {
      return progress.then(success => {
        if (success) {
          this.nextStep();
        }
      })
    }
    return progress && this.nextStep();
  }

  skip() {
    // skip next step if possible otherwise go to last step
    if (this.state.currentStep + 1 < this.props.steps.length) {
      this.setState({
        skippedSteps: [...this.state.skippedSteps, this.state.currentStep + 1]
      });
    }
    const id = this.state.currentStep + 2 < this.props.steps.length ? this.state.currentStep + 2 : this.props.steps.length - 1;
    this.setCurrentStep(id);
  }

  prev() {
    this.setState({
      currentStep: this.state.currentStep === 0 ? 0 : this.state.currentStep - 1
    });
  }

  isLastStep() {
    return this.state.currentStep === this.props.steps.length - 1;
  }

  resolveStepProgressClassName(index: number): string {
    let className;
    if (this.state.currentStep === index && !this.isLastStep()) {
      className = 'active-step';
    } else if (index < this.state.currentStep) {
      className = 'completed-step';
    } else if (this.isLastStep()) {
      className = 'completed-step last-step';
    } else {
      className = 'step';
    }
    if (this.state.skippedSteps.indexOf(index) > -1) {
      className += ' skipped-step';
    }
    return className;
  }

  render() {
    const ActiveStep = this.props.steps[this.state.currentStep].component;
    return (
      <div className={classNames("Wizard", this.props.className)} style={this.props.style}>
        <ul className="wizard-progress">
          {
            this.props.steps.map((step, ind) => (
              <li key={ind} className={this.resolveStepProgressClassName(ind)}>
                <span>{step.name}</span>
              </li>
            ))
          }
          <li className={this.isLastStep() ? 'done' : ''}></li>
        </ul>
        <ActiveStep next={this.next} prev={this.prev} skip={this.skip}/>
      </div>
    );
  }
}
